module.exports = __webpack_public_path__ + "img/nav-bg-sm.58c92eb3.png";